const SocialMediaSources = Object.freeze({
  INSTAGRAM: 'Instagram',
  TWITTER: 'Twitter',
  FACEBOOK: 'Facebook',
  YOUTUBE: 'Youtube',
});

export default SocialMediaSources;
